(function () {
  var SEARCH_TEMPLATE_CLASS = 'template-search';
  var COLLECTION_TEMPLATE_CLASS = 'template-collection';
  var FILTERS_CONTAINER_SELECTOR = '[data-productgrid-sidebar]';
  var FILTERS_MODAL_CONTAINER_SELECTOR = '.modal--productgrid-filters .filter-form, .modal--productgrid-filters [data-productgrid-filters-content]';
  var FILTERS_FALLBACK_CONTAINER_SELECTOR = '.filter-form, [data-productgrid-filters-content]';
  var FILTER_OPTION_SELECTOR = '[data-filter-option]';
  var FILTER_RANGE_SELECTOR = '[data-filter-range]';
  var FILTER_APPLY_SELECTOR = '[data-filter-apply]';
  var FILTER_CLEAR_SELECTOR = '[data-filter-clear]';
  var FILTER_ACTIVE_CHIP_SELECTOR = '[data-filter-active-chip]';
  var FILTER_CLEAR_ALL_LINK_SELECTOR = '[data-filter-clear-all]';
  var LEGACY_FILTER_ITEM_SELECTOR = '.filter-item[data-handle]';
  var LEGACY_FILTER_LINK_SELECTOR = '.filter-item[data-handle] > a[href]';
  var LEGACY_ACTIVE_CHIP_SELECTOR = '[data-legacy-filter-active-chip]';
  var FILTERS_TRIGGER_SELECTOR = '[data-productgrid-trigger-filters]';
  var NAV_FILTER_TRIGGER_SELECTOR = '[data-filter-trigger]';
  var SITE_HEADER_SELECTOR = '[data-site-header]';
  var MODAL_CLASS = 'modal--productgrid-filters';
  var ACTIONS_CLASS = 'filters-apply-actions';
  var APPLY_LABEL = 'Apply';
  var APPLY_LABEL_WITH_COUNT = 'Apply (%count%)';
  var SEARCH_FILTER_TRIGGER_SELECTOR = '[data-mm-search-filter-trigger]';
  var SEARCH_FILTER_DROPDOWN_CLASS = 'mm-search-filter-dropdown';
  var SEARCH_FILTER_DROPDOWN_OPEN_CLASS = 'mm-search-filter-dropdown--open';
  var SEARCH_FILTER_DROPDOWN_READY_CLASS = 'mm-search-filter-dropdown--ready';
  var SEARCH_CARD_SELECTOR = '[data-product-item]';
  var SEARCH_CARD_LINK_SELECTOR = 'a[data-product-page-link][href]';
  var SEARCH_CARD_IGNORE_SELECTOR = 'a, button, input, select, textarea, label, details, summary, [role="button"], [data-gallery-heart-btn], [data-product-actions], [data-swatches], [data-compare-item], .mm-quick-add, .productitem__wishlist';
  var PRICE_SLIDER_READY_ATTR = 'data-mm-price-slider-ready';
  var RATING_SLIDER_READY_ATTR = 'data-mm-rating-slider-ready';
  var SIZE_FILTER_READY_ATTR = 'data-mm-size-filter-ready';
  var SIZE_FILTER_ACTIVE_CHIP_ATTR = 'data-mm-size-filter-active-chip';
  var SIZE_FILTER_GROUP_KEY_ATTR = 'data-mm-size-filter-group-key';
  var RATING_FILTER_LABEL_PATTERN = /product\s+rating\s+count|rating\s+count/i;
  var SIZE_FILTER_LABEL_PATTERN = /selected\s+size/i;

  function isSearchTemplate() {
    return Boolean(document.body && document.body.classList.contains(SEARCH_TEMPLATE_CLASS));
  }

  function isCollectionTemplate() {
    return Boolean(document.body && document.body.classList.contains(COLLECTION_TEMPLATE_CLASS));
  }

  function isSupportedTemplate() {
    return isSearchTemplate() || isCollectionTemplate();
  }

  function isMobileSearchCardExperience() {
    if (!isSearchTemplate()) return false;
    if (!window.matchMedia) return true;
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function getModalRoot(node) {
    return node && node.closest ? node.closest('.' + MODAL_CLASS) : null;
  }

  function getSearchFilterDropdownRoot(node) {
    return node && node.closest
      ? node.closest('.' + SEARCH_FILTER_DROPDOWN_CLASS + '.' + SEARCH_FILTER_DROPDOWN_OPEN_CLASS)
      : null;
  }

  function getProductGridFilterSurfaceRoot(node) {
    if (!isSupportedTemplate() || !node || !node.closest) return null;

    var filtersContainer = node.closest(FILTERS_CONTAINER_SELECTOR);
    if (filtersContainer) {
      return filtersContainer.closest('.productgrid--outer') || filtersContainer.closest('.productgrid--wrapper') || filtersContainer;
    }

    var activeFilters = node.closest('.productgrid--filters');
    if (activeFilters) {
      return activeFilters.closest('.productgrid--outer') || activeFilters.closest('.productgrid--wrapper') || activeFilters;
    }

    var filterForm = node.closest('.filter-form');
    if (filterForm) {
      return filterForm.closest('.productgrid--outer') || filterForm.closest('.productgrid--wrapper') || filterForm;
    }

    return null;
  }

  function getFilterSurfaceRoot(node) {
    return getModalRoot(node) || getSearchFilterDropdownRoot(node) || getProductGridFilterSurfaceRoot(node);
  }

  function getFiltersContainer(rootNode) {
    if (rootNode && rootNode.closest) {
      var closestContainer = rootNode.closest(FILTERS_CONTAINER_SELECTOR);
      if (closestContainer) {
        return closestContainer;
      }

      var closestFallbackContainer = rootNode.closest(FILTERS_FALLBACK_CONTAINER_SELECTOR);
      if (closestFallbackContainer) {
        return closestFallbackContainer;
      }
    }

    if (rootNode && rootNode.matches && rootNode.matches(FILTERS_CONTAINER_SELECTOR)) {
      return rootNode;
    }

    if (rootNode && rootNode.matches && rootNode.matches(FILTERS_FALLBACK_CONTAINER_SELECTOR)) {
      return rootNode;
    }

    if (rootNode && rootNode.querySelector) {
      var scopedContainer = rootNode.querySelector(FILTERS_CONTAINER_SELECTOR);
      if (scopedContainer) {
        return scopedContainer;
      }

      var scopedFallbackContainer = rootNode.querySelector(FILTERS_FALLBACK_CONTAINER_SELECTOR);
      if (scopedFallbackContainer) {
        return scopedFallbackContainer;
      }
    }

    var modal = document.querySelector('.' + MODAL_CLASS);
    if (modal) {
      var modalFilters = modal.querySelector(FILTERS_CONTAINER_SELECTOR);
      if (modalFilters) {
        return modalFilters;
      }

      var modalFallbackFilters = modal.querySelector(FILTERS_FALLBACK_CONTAINER_SELECTOR);
      if (modalFallbackFilters) {
        return modalFallbackFilters;
      }
    }

    return document.querySelector(FILTERS_CONTAINER_SELECTOR);
  }

  function getCurrentFiltersContainer(node) {
    if (node && node.closest) {
      var closestContainer = node.closest(FILTERS_CONTAINER_SELECTOR);
      if (closestContainer) return closestContainer;

      var closestFallbackContainer = node.closest(FILTERS_FALLBACK_CONTAINER_SELECTOR);
      if (closestFallbackContainer) return closestFallbackContainer;
    }

    return getFiltersContainer(getFilterSurfaceRoot(node));
  }

  function getFiltersContainers(rootNode) {
    if (rootNode) {
      var scopedContainer = getFiltersContainer(rootNode);
      return scopedContainer ? [scopedContainer] : [];
    }

    var containers = [];
    var seen = [];
    var selector = FILTERS_CONTAINER_SELECTOR + ', ' + FILTERS_MODAL_CONTAINER_SELECTOR;
    var nodes = document.querySelectorAll(selector);

    nodes.forEach(function (container) {
      if (seen.indexOf(container) !== -1) return;
      seen.push(container);
      containers.push(container);
    });

    return containers;
  }

  function hasFacetedFilters(rootNode) {
    var filtersContainer = getFiltersContainer(rootNode);
    if (!filtersContainer) return false;
    return Boolean(filtersContainer.querySelector(FILTER_OPTION_SELECTOR + '[data-name][data-value], ' + FILTER_RANGE_SELECTOR + '[name]'));
  }

  function hasLegacyTagFilters(rootNode) {
    var filtersContainer = getFiltersContainer(rootNode);
    if (!filtersContainer) return false;
    return Boolean(filtersContainer.querySelector(LEGACY_FILTER_LINK_SELECTOR));
  }

  function shouldEnable(rootNode) {
    return isSupportedTemplate() && (hasFacetedFilters(rootNode) || hasLegacyTagFilters(rootNode));
  }

  function isInFiltersModal(node) {
    return Boolean(getFilterSurfaceRoot(node));
  }

  function isMobileSearchFilterDropdown() {
    if (!isSearchTemplate()) return false;
    if (!window.matchMedia) return true;
    return window.matchMedia('(max-width: 859px)').matches;
  }

  function getSearchFilterTrigger() {
    return document.querySelector(SEARCH_FILTER_TRIGGER_SELECTOR);
  }

  function getSearchFilterDropdown(trigger) {
    var scope = trigger && trigger.closest ? trigger.closest('.productgrid--wrapper') : null;
    if (scope && scope.querySelector) {
      return scope.querySelector(FILTERS_CONTAINER_SELECTOR);
    }

    return document.querySelector(FILTERS_CONTAINER_SELECTOR);
  }

  function prepareSearchFilterDropdown(trigger) {
    if (!trigger) return null;

    var dropdown = getSearchFilterDropdown(trigger);
    if (!dropdown) return null;

    if (!dropdown.id) {
      dropdown.id = 'mm-search-filter-dropdown';
    }

    dropdown.classList.add(SEARCH_FILTER_DROPDOWN_CLASS, SEARCH_FILTER_DROPDOWN_READY_CLASS);
    dropdown.setAttribute('role', 'region');
    dropdown.setAttribute('aria-label', 'Search filters');
    dropdown.setAttribute('aria-hidden', dropdown.classList.contains(SEARCH_FILTER_DROPDOWN_OPEN_CLASS) ? 'false' : 'true');

    trigger.setAttribute('aria-controls', dropdown.id);
    trigger.setAttribute('aria-haspopup', 'true');
    if (!trigger.hasAttribute('aria-expanded')) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    return dropdown;
  }

  function setSearchFilterDropdownOpen(trigger, isOpen) {
    var dropdown = prepareSearchFilterDropdown(trigger);
    if (!dropdown) return;

    dropdown.classList.toggle(SEARCH_FILTER_DROPDOWN_OPEN_CLASS, isOpen);
    dropdown.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.documentElement.classList.toggle('mm-search-filter-dropdown-open', isOpen);

    if (isOpen) {
      refreshFilterEnhancements(dropdown);
    }
  }

  function closeSearchFilterDropdown(options) {
    var settings = options || {};
    var trigger = getSearchFilterTrigger();
    if (!trigger) return;

    var dropdown = getSearchFilterDropdown(trigger);
    if (!dropdown || !dropdown.classList.contains(SEARCH_FILTER_DROPDOWN_OPEN_CLASS)) return;

    setSearchFilterDropdownOpen(trigger, false);

    if (settings.focusTrigger && trigger.focus) {
      trigger.focus();
    }
  }

  function resetSearchFilterDropdown() {
    var trigger = getSearchFilterTrigger();
    if (!trigger) return;

    var dropdown = getSearchFilterDropdown(trigger);
    if (!dropdown) return;

    dropdown.classList.remove(
      SEARCH_FILTER_DROPDOWN_CLASS,
      SEARCH_FILTER_DROPDOWN_READY_CLASS,
      SEARCH_FILTER_DROPDOWN_OPEN_CLASS
    );
    dropdown.removeAttribute('aria-hidden');
    dropdown.removeAttribute('role');
    dropdown.removeAttribute('aria-label');
    trigger.removeAttribute('aria-controls');
    trigger.removeAttribute('aria-haspopup');
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mm-search-filter-dropdown-open');
  }

  function toggleSearchFilterDropdown(trigger, event) {
    if (!isMobileSearchFilterDropdown()) return false;

    var dropdown = prepareSearchFilterDropdown(trigger);
    if (!dropdown || !shouldEnable(dropdown)) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    setSearchFilterDropdownOpen(trigger, !dropdown.classList.contains(SEARCH_FILTER_DROPDOWN_OPEN_CLASS));
    return true;
  }

  function getStickySidebarElements() {
    return document.querySelectorAll(FILTERS_CONTAINER_SELECTOR);
  }

  function syncStickySidebarOffset() {
    if (!isSupportedTemplate()) return;

    var sidebars = getStickySidebarElements();
    if (!sidebars.length) return;

    if (window.matchMedia && !window.matchMedia('(min-width: 860px)').matches) {
      sidebars.forEach(function (sidebar) {
        sidebar.style.removeProperty('--productgrid-sidebar-top-offset');
      });
      return;
    }

    var body = document.body;
    var header = document.querySelector(SITE_HEADER_SELECTOR);
    var headerIsSticky = Boolean(body && body.classList.contains('site-header-sticky'));
    var headerHeight = header && header.getBoundingClientRect
      ? Math.ceil(header.getBoundingClientRect().height)
      : 0;
    var stickyGap = 16;
    var offset = headerIsSticky
      ? Math.max(headerHeight + stickyGap, 96)
      : stickyGap;

    sidebars.forEach(function (sidebar) {
      sidebar.style.setProperty('--productgrid-sidebar-top-offset', offset + 'px');
    });
  }

  function scheduleStickySidebarOffsetSync() {
    if (document.documentElement.__mmStickySidebarOffsetPending) return;

    document.documentElement.__mmStickySidebarOffsetPending = true;

    window.requestAnimationFrame(function () {
      document.documentElement.__mmStickySidebarOffsetPending = false;
      syncStickySidebarOffset();
    });
  }

  function bindStickySidebarOffsetSync() {
    if (document.documentElement.__mmStickySidebarOffsetBound) return;

    document.documentElement.__mmStickySidebarOffsetBound = true;
    window.addEventListener('resize', scheduleStickySidebarOffsetSync);
    window.addEventListener('scroll', scheduleStickySidebarOffsetSync);
  }

  function setCheckmarkState(link, state) {
    var checkmark = link.querySelector('.checkmark');
    if (!checkmark) return;

    checkmark.setAttribute('data-animation-state', state);
    var parts = checkmark.querySelectorAll('[data-animation-state]');
    parts.forEach(function (part) {
      part.setAttribute('data-animation-state', state);
    });
  }

  function findFilterOption(filtersContainer, name, value) {
    if (!filtersContainer || !name || value === null) return null;

    var options = filtersContainer.querySelectorAll(FILTER_OPTION_SELECTOR + '[data-name][data-value]');
    for (var i = 0; i < options.length; i += 1) {
      if (
        options[i].getAttribute('data-name') === String(name)
        && options[i].getAttribute('data-value') === String(value)
      ) {
        return options[i];
      }
    }

    return null;
  }

  function clearRangeInputByName(filtersContainer, name) {
    if (!filtersContainer || !name) return;

    var rangeInputs = filtersContainer.querySelectorAll(FILTER_RANGE_SELECTOR + '[name]');
    rangeInputs.forEach(function (input) {
      if (input.getAttribute('name') === name) {
        input.value = '';
      }
    });
  }

  function setFilterOptionState(link, isActive) {
    if (isActive) {
      link.setAttribute('data-filter-active', '');
    } else {
      link.removeAttribute('data-filter-active');
    }

    link.setAttribute('aria-checked', isActive ? 'true' : 'false');

    var listItem = link.closest('.collection-filters__filter-list-item');
    if (listItem) {
      listItem.classList.toggle('collection-filters__filter-list-item--active', isActive);
      listItem.setAttribute('data-filter-open', isActive ? 'true' : 'false');
    }

    setCheckmarkState(link, isActive ? 'checked' : 'unchecked');
  }

  function getLegacyFilterItem(node) {
    return node && node.closest ? node.closest(LEGACY_FILTER_ITEM_SELECTOR) : null;
  }

  function getLegacyFilterHandle(item) {
    return item ? item.getAttribute('data-handle') : '';
  }

  function setLegacyFilterState(item, isActive) {
    if (!item) return;

    item.setAttribute('data-filter-active', isActive ? 'true' : 'false');
    item.classList.toggle('filter-item--active', isActive);
    if (isActive) {
      item.setAttribute('aria-current', 'true');
    } else {
      item.removeAttribute('aria-current');
    }

    var link = item.querySelector('a[href]');
    if (link) {
      link.setAttribute('role', 'checkbox');
      link.setAttribute('aria-checked', isActive ? 'true' : 'false');
    }

    setCheckmarkState(item, isActive ? 'checked' : 'unchecked');
  }

  function toggleLegacyFilter(link) {
    var item = getLegacyFilterItem(link);
    if (!item || item.classList.contains('filter-item--disabled')) return;

    var group = item.closest('[data-filter-group]');
    var isActive = item.getAttribute('data-filter-active') === 'true';

    if (!isActive && group) {
      var activeSiblings = group.querySelectorAll(LEGACY_FILTER_ITEM_SELECTOR + '[data-filter-active="true"]');
      activeSiblings.forEach(function (sibling) {
        setLegacyFilterState(sibling, false);
      });
    }

    setLegacyFilterState(item, !isActive);
  }

  function toggleFilter(link) {
    setFilterOptionState(link, !link.hasAttribute('data-filter-active'));
  }

  function getSelectedFilterCount(filtersContainer) {
    if (!filtersContainer) return 0;

    var groupedSizeSelection = getGroupedSizeSelection(filtersContainer);
    var count = groupedSizeSelection.count;
    var groupedSizeOptions = groupedSizeSelection.options;
    var activeOptions = filtersContainer.querySelectorAll(FILTER_OPTION_SELECTOR + '[data-filter-active]');
    activeOptions.forEach(function (option) {
      if (groupedSizeOptions.indexOf(option) === -1) {
        count += 1;
      }
    });

    count += filtersContainer.querySelectorAll(LEGACY_FILTER_ITEM_SELECTOR + '[data-filter-active="true"]').length;

    var rangeInputs = filtersContainer.querySelectorAll(FILTER_RANGE_SELECTOR);
    rangeInputs.forEach(function (input) {
      if (input.value && input.value.trim()) {
        count += 1;
      }
    });

    return count;
  }

  function updateActionButtonsState(filtersContainer) {
    if (!filtersContainer) return;

    var actions = filtersContainer.querySelector('.' + ACTIONS_CLASS);
    if (!actions) return;

    var applyButton = actions.querySelector(FILTER_APPLY_SELECTOR);
    var clearButton = actions.querySelector(FILTER_CLEAR_SELECTOR);
    var selectedCount = getSelectedFilterCount(filtersContainer);
    var hasFilters = selectedCount > 0;

    if (applyButton) {
      applyButton.textContent = hasFilters
        ? APPLY_LABEL_WITH_COUNT.replace('%count%', String(selectedCount))
        : APPLY_LABEL;
      applyButton.disabled = false;
    }

    if (clearButton) {
      clearButton.disabled = !hasFilters;
    }

    actions.style.display = hasFilters ? '' : 'none';
  }

  function parseSliderNumber(value, fallback) {
    var rawValue = value === null || value === undefined ? '' : String(value);
    var number = parseFloat(rawValue.replace(/[^0-9.-]/g, ''));
    return isNaN(number) ? fallback : number;
  }

  function clampSliderNumber(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function formatSliderNumber(value) {
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getFilterGroupLabel(group) {
    if (!group) return '';

    var title = group.querySelector('.collection-filters__filter-group-title, .collection-filters__filter-title');
    if (title && title.textContent) {
      return title.textContent.replace(/\s+/g, ' ').trim();
    }

    return group.getAttribute('aria-label') || '';
  }

  function normalizeFilterText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function getFilterOptionLabel(link) {
    if (!link) return '';

    var textNode = link.querySelector('.collection-filters__filter-list-item-text');
    var label = normalizeFilterText(textNode ? textNode.textContent : link.textContent);
    return label.replace(/\s*\(\s*[\d,]+\s*\)\s*$/, '').trim();
  }

  function getFilterOptionCount(link) {
    if (!link) return 0;

    var countNode = link.querySelector('.collection-filters__filter-count');
    var countText = countNode ? countNode.textContent : link.textContent;
    var countMatch = normalizeFilterText(countText).match(/\(([\d,]+)\)\s*$/);
    if (!countMatch && countNode) {
      countMatch = normalizeFilterText(countNode.textContent).match(/([\d,]+)/);
    }

    return countMatch ? parseInt(countMatch[1].replace(/,/g, ''), 10) || 0 : 0;
  }

  function getRangeCurrency(rangeGroup) {
    var currency = rangeGroup.querySelector('.collection-filters__filter-range-currency');
    return currency && currency.textContent ? currency.textContent.trim() : '$';
  }

  function getProductGridRoot(node) {
    if (node && node.closest) {
      var scopedRoot = node.closest('.productgrid--outer');
      if (scopedRoot) return scopedRoot;
    }

    return document.querySelector('.productgrid--outer');
  }

  function collectVisibleProductPrices(filtersContainer) {
    var root = getProductGridRoot(filtersContainer);
    var cards = root ? root.querySelectorAll('.productgrid--items [data-product-item]') : [];
    var prices = [];

    cards.forEach(function (card) {
      var priceNode = card.querySelector('.price__current .money') || card.querySelector('.productitem--price-wrap .money');
      if (!priceNode || !priceNode.textContent) return;

      var price = parseSliderNumber(priceNode.textContent, NaN);
      if (!isNaN(price)) {
        prices.push(price);
      }
    });

    return prices;
  }

  function createFilterHistogram(values, min, max, options) {
    var settings = options || {};
    var histogram = document.createElement('div');
    var binCount = settings.binCount || Math.min(Math.max(values.length, 8), 18);
    var bins = [];
    var maxBin = 1;
    var spread = Math.max(max - min, 1);

    for (var i = 0; i < binCount; i += 1) {
      bins.push(0);
    }

    values.forEach(function (value) {
      var index = Math.floor(((value - min) / spread) * binCount);
      index = clampSliderNumber(index, 0, binCount - 1);
      bins[index] += 1;
      maxBin = Math.max(maxBin, bins[index]);
    });

    histogram.className = 'mm-filter-histogram' + (settings.className ? ' ' + settings.className : '');
    if (settings.attrName) {
      histogram.setAttribute(settings.attrName, '');
    }
    histogram.setAttribute('aria-hidden', 'true');

    bins.forEach(function (count) {
      var bar = document.createElement('span');
      var barFill = document.createElement('span');
      var scaledHeight = count > 0 ? Math.sqrt(count / maxBin) * 100 : 0;
      var height = count > 0 ? Math.max(24, Math.round(scaledHeight)) : 0;

      bar.className = 'mm-filter-histogram__bar' + (count > 0 ? '' : ' mm-filter-histogram__bar--empty');
      bar.setAttribute('data-mm-filter-bar-count', String(count));
      bar.style.setProperty('--mm-filter-bar-height', height + '%');
      barFill.className = 'mm-filter-histogram__bar-fill';
      bar.appendChild(barFill);
      histogram.appendChild(bar);
    });

    return histogram;
  }

  function setSliderTrack(sliderWrap, minValue, maxValue, min, max) {
    if (!sliderWrap) return;

    var spread = Math.max(max - min, 1);
    var lower = ((minValue - min) / spread) * 100;
    var upper = ((maxValue - min) / spread) * 100;

    sliderWrap.style.setProperty('--mm-slider-lower', lower + '%');
    sliderWrap.style.setProperty('--mm-slider-upper', upper + '%');
  }

  function updatePriceSliderState(slider, source) {
    if (!slider) return;

    var filtersContainer = getFiltersContainer(slider);
    var minInput = slider.__mmMinInput;
    var maxInput = slider.__mmMaxInput;
    var minSlider = slider.querySelector('[data-mm-price-min-slider]');
    var maxSlider = slider.querySelector('[data-mm-price-max-slider]');
    var output = slider.querySelector('[data-mm-slider-value]');
    var sliderWrap = slider.querySelector('.mm-filter-slider__range-wrap');
    if (!minInput || !maxInput || !minSlider || !maxSlider) return;

    var min = parseSliderNumber(minSlider.min, 0);
    var max = parseSliderNumber(maxSlider.max, parseSliderNumber(maxInput.max, 0));
    var minValue = clampSliderNumber(parseSliderNumber(minSlider.value, min), min, max);
    var maxValue = clampSliderNumber(parseSliderNumber(maxSlider.value, max), min, max);

    if (minValue > maxValue) {
      if (source === maxSlider) {
        minValue = maxValue;
        minSlider.value = String(minValue);
      } else {
        maxValue = minValue;
        maxSlider.value = String(maxValue);
      }
    }

    minSlider.value = String(minValue);
    maxSlider.value = String(maxValue);
    minInput.value = minValue > min ? String(Math.round(minValue)) : '';
    maxInput.value = maxValue < max ? String(Math.round(maxValue)) : '';

    var currency = slider.getAttribute('data-mm-slider-currency') || '$';
    var label = minValue <= min && maxValue >= max
      ? 'Any price'
      : currency + formatSliderNumber(minValue) + ' - ' + currency + formatSliderNumber(maxValue);

    if (output) {
      output.textContent = label;
    }

    minSlider.setAttribute('aria-valuetext', 'Minimum price ' + currency + formatSliderNumber(minValue));
    maxSlider.setAttribute('aria-valuetext', 'Maximum price ' + currency + formatSliderNumber(maxValue));
    setSliderTrack(sliderWrap, minValue, maxValue, min, max);
    updateActionButtonsState(filtersContainer);
  }

  function syncPriceSlider(slider) {
    if (!slider) return;

    var minInput = slider.__mmMinInput;
    var maxInput = slider.__mmMaxInput;
    var minSlider = slider.querySelector('[data-mm-price-min-slider]');
    var maxSlider = slider.querySelector('[data-mm-price-max-slider]');
    if (!minInput || !maxInput || !minSlider || !maxSlider) return;

    var min = parseSliderNumber(minSlider.min, 0);
    var max = parseSliderNumber(maxSlider.max, parseSliderNumber(maxInput.max, 0));
    minSlider.value = String(clampSliderNumber(parseSliderNumber(minInput.value, min), min, max));
    maxSlider.value = String(clampSliderNumber(parseSliderNumber(maxInput.value, max), min, max));
    updatePriceSliderState(slider);
  }

  function createRangeInput(className, label, min, max, step, value, attrName) {
    var input = document.createElement('input');
    input.type = 'range';
    input.className = className;
    input.min = String(min);
    input.max = String(max);
    input.step = String(step);
    input.value = String(value);
    input.setAttribute('aria-label', label);
    input.setAttribute(attrName, '');
    return input;
  }

  function enhancePriceSliders(filtersContainer) {
    if (!isSupportedTemplate() || !filtersContainer) return;

    var rangeGroups = filtersContainer.querySelectorAll('[data-filter-group-range]');
    rangeGroups.forEach(function (rangeGroup) {
      if (rangeGroup.hasAttribute(PRICE_SLIDER_READY_ATTR)) return;

      var inputs = rangeGroup.querySelectorAll(FILTER_RANGE_SELECTOR + '[name]');
      if (inputs.length < 2) return;

      var minInput = inputs[0];
      var maxInput = inputs[1];
      var group = rangeGroup.closest('.collection-filters__filter-group');
      var label = getFilterGroupLabel(group) || 'Price';
      var min = parseSliderNumber(minInput.min, 0);
      var max = parseSliderNumber(maxInput.max || minInput.max || maxInput.placeholder, 0);
      if (max <= min) return;

      var currentMin = clampSliderNumber(parseSliderNumber(minInput.value, min), min, max);
      var currentMax = clampSliderNumber(parseSliderNumber(maxInput.value, max), min, max);
      var currency = getRangeCurrency(rangeGroup);
      var slider = document.createElement('div');
      var sliderHeader = document.createElement('div');
      var sliderTitle = document.createElement('span');
      var sliderValue = document.createElement('span');
      var sliderWrap = document.createElement('div');
      var bounds = document.createElement('div');
      var lowerBound = document.createElement('span');
      var upperBound = document.createElement('span');

      slider.className = 'mm-filter-slider mm-filter-slider--price';
      slider.setAttribute('data-mm-price-slider', '');
      slider.setAttribute('data-mm-slider-currency', currency);
      slider.__mmMinInput = minInput;
      slider.__mmMaxInput = maxInput;

      sliderHeader.className = 'mm-filter-slider__header';
      sliderTitle.className = 'mm-filter-slider__title';
      sliderTitle.textContent = label;
      sliderValue.className = 'mm-filter-slider__value';
      sliderValue.setAttribute('data-mm-slider-value', '');
      sliderHeader.appendChild(sliderTitle);
      sliderHeader.appendChild(sliderValue);

      sliderWrap.className = 'mm-filter-slider__range-wrap';
      var minSlider = createRangeInput(
        'mm-filter-slider__range mm-filter-slider__range--min',
        'Minimum ' + label.toLowerCase(),
        min,
        max,
        1,
        currentMin,
        'data-mm-price-min-slider'
      );
      var maxSlider = createRangeInput(
        'mm-filter-slider__range mm-filter-slider__range--max',
        'Maximum ' + label.toLowerCase(),
        min,
        max,
        1,
        currentMax,
        'data-mm-price-max-slider'
      );
      sliderWrap.appendChild(minSlider);
      sliderWrap.appendChild(maxSlider);

      bounds.className = 'mm-filter-slider__bounds';
      lowerBound.textContent = currency + formatSliderNumber(min);
      upperBound.textContent = currency + formatSliderNumber(max);
      bounds.appendChild(lowerBound);
      bounds.appendChild(upperBound);

      slider.appendChild(sliderHeader);
      slider.appendChild(createFilterHistogram(collectVisibleProductPrices(filtersContainer), min, max, {
        attrName: 'data-mm-price-histogram',
        className: 'mm-filter-histogram--price',
        binCount: 18
      }));
      slider.appendChild(sliderWrap);
      slider.appendChild(bounds);

      rangeGroup.classList.add('mm-filter-slider__native-inputs');
      rangeGroup.setAttribute('aria-hidden', 'true');
      minInput.tabIndex = -1;
      maxInput.tabIndex = -1;
      if (group) {
        group.classList.add('collection-filters__filter-group--price-slider');
      }
      rangeGroup.setAttribute(PRICE_SLIDER_READY_ATTR, '');
      rangeGroup.parentNode.insertBefore(slider, rangeGroup);

      minSlider.addEventListener('input', function (event) {
        updatePriceSliderState(slider, event.target);
      });
      maxSlider.addEventListener('input', function (event) {
        updatePriceSliderState(slider, event.target);
      });
      minSlider.addEventListener('change', function () {
        applyFilters(getFiltersContainer(slider));
      });
      maxSlider.addEventListener('change', function () {
        applyFilters(getFiltersContainer(slider));
      });

      updatePriceSliderState(slider);
    });
  }

  function getRatingSliderItems(group) {
    var links = group.querySelectorAll(FILTER_OPTION_SELECTOR + '[data-name][data-value]');
    var items = [];

    links.forEach(function (link) {
      if (link.hasAttribute('data-disabled') || link.getAttribute('aria-disabled') === 'true') return;

      var rawLabel = link.textContent ? link.textContent.replace(/\s+/g, ' ').trim() : '';
      items.push({
        link: link,
        label: getFilterOptionLabel(link) || rawLabel || link.getAttribute('data-value'),
        count: getFilterOptionCount(link),
        numericValue: parseSliderNumber(link.getAttribute('data-value'), items.length + 1)
      });
    });

    items.sort(function (a, b) {
      return a.numericValue - b.numericValue;
    });

    return items;
  }

  function enhanceRatingSliders(filtersContainer) {
    if (!isSupportedTemplate() || !filtersContainer) return;

    var groups = filtersContainer.querySelectorAll('.collection-filters__filter-group');
    groups.forEach(function (group) {
      if (group.hasAttribute(RATING_SLIDER_READY_ATTR)) return;

      var label = getFilterGroupLabel(group);
      if (!RATING_FILTER_LABEL_PATTERN.test(label)) return;

      var list = group.querySelector('[data-filter-group-list], .collection-filters__filter-list');
      if (!list) return;

      var items = getRatingSliderItems(group);
      if (!items.length) return;

      items.forEach(function (item) {
        item.link.tabIndex = -1;
      });

      group.classList.add('collection-filters__filter-group--rating-hidden');
      group.setAttribute(RATING_SLIDER_READY_ATTR, '');
      group.hidden = true;
      list.setAttribute('aria-hidden', 'true');
    });
  }

  function normalizeSizeText(label) {
    return normalizeFilterText(label)
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/[\u2018\u2019]/g, "'");
  }

  function formatGallonBucketLabel(value) {
    var rounded = Math.round(value);
    var bucketNumber = rounded === value ? String(rounded) : String(value);
    return bucketNumber + ' Gallon';
  }

  function classifySizeBucket(label) {
    var normalized = normalizeSizeText(label);
    var gallonMatch = normalized.match(/(\d+(?:\.\d+)?)\s*[- ]?\s*(?:gallon|gal)\b/);

    if (/ball\s*(?:&|and)\s*burlap|b\s*&\s*b|balled\s*(?:&|and)\s*burlapped|\bburlap\b/.test(normalized)) {
      return {
        key: 'ball-burlap',
        label: 'Ball & Burlap',
        sortValue: 10000
      };
    }

    if (
      /welsh\s*pot|welshpot|\bquart\b|\bqt\b|small\s*1\s*(?:gallon|gal)|one\s*gallon/.test(normalized)
    ) {
      return {
        key: 'gallon-1',
        label: '1 Gallon',
        sortValue: 1
      };
    }

    if (gallonMatch) {
      var gallonValue = parseFloat(gallonMatch[1]);
      if (!isNaN(gallonValue)) {
        return {
          key: 'gallon-' + String(gallonValue).replace('.', '-'),
          label: formatGallonBucketLabel(gallonValue),
          sortValue: gallonValue
        };
      }
    }

    return {
      key: 'specialty-sizes',
      label: 'Specialty Sizes',
      sortValue: 11000
    };
  }

  function getSizeFilterGroups(group) {
    var links = group.querySelectorAll(FILTER_OPTION_SELECTOR + '[data-name][data-value]');
    var groupsByKey = {};
    var groups = [];

    links.forEach(function (link, index) {
      var label = getFilterOptionLabel(link);
      var count = getFilterOptionCount(link);
      if (count <= 0) return;

      var bucket = classifySizeBucket(label);
      if (!groupsByKey[bucket.key]) {
        groupsByKey[bucket.key] = {
          key: bucket.key,
          label: bucket.label,
          sortValue: bucket.sortValue,
          index: index,
          count: 0,
          links: []
        };
        groups.push(groupsByKey[bucket.key]);
      }

      groupsByKey[bucket.key].count += count;
      groupsByKey[bucket.key].links.push(link);
    });

    groups.sort(function (a, b) {
      if (a.sortValue !== b.sortValue) {
        return a.sortValue - b.sortValue;
      }

      return a.index - b.index;
    });

    return groups;
  }

  function getSizeControlLinks(control) {
    return control && control.__mmLinkedFilterOptions ? control.__mmLinkedFilterOptions : [];
  }

  function setSizeChipState(chip) {
    var links = getSizeControlLinks(chip);
    var activeCount = 0;

    links.forEach(function (link) {
      if (link.hasAttribute('data-filter-active')) {
        activeCount += 1;
      }
    });

    var isActive = activeCount > 0;
    var state = 'false';
    if (links.length && activeCount === links.length) {
      state = 'true';
    } else if (activeCount > 0) {
      state = 'mixed';
    }

    chip.classList.toggle('mm-size-filter__chip--active', isActive);
    chip.classList.toggle('mm-size-filter__option--active', isActive);
    chip.setAttribute('aria-checked', state);
    if (isActive) {
      chip.setAttribute('data-filter-active', '');
    } else {
      chip.removeAttribute('data-filter-active');
    }
  }

  function getGroupedSizeSelection(filtersContainer) {
    var selection = {
      count: 0,
      options: []
    };
    if (!filtersContainer) return selection;

    var chips = filtersContainer.querySelectorAll('[data-mm-size-filter-chip]');
    chips.forEach(function (chip) {
      var links = getSizeControlLinks(chip);
      var activeLinks = [];

      links.forEach(function (link) {
        if (link.hasAttribute('data-filter-active')) {
          activeLinks.push(link);
        }
      });

      if (activeLinks.length) {
        selection.count += 1;
        activeLinks.forEach(function (link) {
          if (selection.options.indexOf(link) === -1) {
            selection.options.push(link);
          }
        });
      }
    });

    return selection;
  }

  function getSizeControlForOption(filtersContainer, name, value) {
    if (!filtersContainer || !name || value === null) return null;

    var controls = filtersContainer.querySelectorAll('[data-mm-size-filter-chip]');
    for (var i = 0; i < controls.length; i += 1) {
      var links = getSizeControlLinks(controls[i]);
      for (var j = 0; j < links.length; j += 1) {
        if (
          links[j].getAttribute('data-name') === String(name)
          && links[j].getAttribute('data-value') === String(value)
        ) {
          return controls[i];
        }
      }
    }

    return null;
  }

  function getSizeControlByKey(filtersContainer, key) {
    if (!filtersContainer || !key) return null;
    return filtersContainer.querySelector('[data-mm-size-filter-chip][' + SIZE_FILTER_GROUP_KEY_ATTR + '="' + key.replace(/"/g, '\\"') + '"]');
  }

  function getActiveChipWrapper(chip) {
    return chip ? chip.closest('li') || chip : null;
  }

  function setActiveChipText(chip, label) {
    if (!chip) return;

    var text = chip.querySelector('.active-filter-text, .filter-text');
    if (text) {
      text.textContent = label;
    } else {
      chip.textContent = label;
    }

    chip.setAttribute('aria-label', 'Remove ' + label + ' filter');
  }

  function syncGroupedSizeActiveChips(filtersContainer) {
    if (!filtersContainer) return;

    var root = getProductGridRoot(filtersContainer) || document;
    var chipLists = root.querySelectorAll('.active-filter-group');

    chipLists.forEach(function (list) {
      var groups = {};
      var chips = list.querySelectorAll(FILTER_ACTIVE_CHIP_SELECTOR + '[data-name][data-value]');

      chips.forEach(function (chip) {
        if (chip.hasAttribute(SIZE_FILTER_ACTIVE_CHIP_ATTR)) return;

        var control = getSizeControlForOption(
          filtersContainer,
          chip.getAttribute('data-name'),
          chip.getAttribute('data-value')
        );
        if (!control) return;

        var key = control.getAttribute(SIZE_FILTER_GROUP_KEY_ATTR);
        if (!key) return;

        if (!groups[key]) {
          groups[key] = {
            control: control,
            chips: []
          };
        }
        groups[key].chips.push(chip);
      });

      Object.keys(groups).forEach(function (key) {
        var group = groups[key];
        var primary = group.chips[0];
        var label = group.control.getAttribute('data-mm-size-filter-label') || 'Size';

        primary.setAttribute(SIZE_FILTER_ACTIVE_CHIP_ATTR, '');
        primary.setAttribute(SIZE_FILTER_GROUP_KEY_ATTR, key);
        setActiveChipText(primary, label);

        group.chips.slice(1).forEach(function (chip) {
          var wrapper = getActiveChipWrapper(chip);
          if (wrapper && wrapper.parentNode) {
            wrapper.parentNode.removeChild(wrapper);
          }
        });
      });
    });
  }

  function removeGroupedSizeActiveChips(filtersContainer, key) {
    if (!filtersContainer || !key) return;

    var root = getProductGridRoot(filtersContainer) || document;
    var chips = root.querySelectorAll(
      '[' + SIZE_FILTER_ACTIVE_CHIP_ATTR + '][' + SIZE_FILTER_GROUP_KEY_ATTR + '="' + key.replace(/"/g, '\\"') + '"]'
    );

    chips.forEach(function (chip) {
      var wrapper = getActiveChipWrapper(chip);
      if (wrapper && wrapper.parentNode) {
        wrapper.parentNode.removeChild(wrapper);
      }
    });
  }

  function syncSizeFilterUI(filtersContainer) {
    if (!filtersContainer) return;

    var chips = filtersContainer.querySelectorAll('[data-mm-size-filter-chip]');
    chips.forEach(setSizeChipState);
    syncGroupedSizeActiveChips(filtersContainer);
  }

  function handleSizeChipToggle(chip) {
    if (!chip || chip.disabled) return;

    var filtersContainer = getFiltersContainer(getFilterSurfaceRoot(chip));
    var links = getSizeControlLinks(chip);
    if (!filtersContainer || !links.length) return;

    var shouldActivate = chip.getAttribute('aria-checked') !== 'true';
    links.forEach(function (link) {
      if (link.hasAttribute('data-disabled') || link.getAttribute('aria-disabled') === 'true') return;
      setFilterOptionState(link, shouldActivate);
    });

    applyFilters(filtersContainer);
  }

  function createSizeFilterUI(group, items) {
    var ui = document.createElement('div');
    var chipList = document.createElement('div');

    ui.className = 'mm-size-filter';
    ui.setAttribute('data-mm-size-filter-ui', '');

    chipList.className = 'mm-size-filter__options';
    ui.appendChild(chipList);

    items.forEach(function (item) {
      var chip = document.createElement('button');
      var label = document.createElement('span');
      var count = document.createElement('span');
      var text = document.createElement('span');
      var enabledLinks = item.links.filter(function (link) {
        return !link.hasAttribute('data-disabled') && link.getAttribute('aria-disabled') !== 'true';
      });

      chip.type = 'button';
      chip.className = 'mm-size-filter__chip mm-size-filter__option mm-size-filter__option--aggregate';
      chip.setAttribute('role', 'checkbox');
      chip.setAttribute('data-mm-size-filter-chip', '');
      chip.setAttribute(SIZE_FILTER_GROUP_KEY_ATTR, item.key);
      chip.setAttribute('data-mm-size-filter-label', item.label);
      chip.setAttribute('aria-label', item.label + (item.count ? ', ' + item.count + ' products' : ''));
      chip.__mmLinkedFilterOptions = item.links;

      if (!enabledLinks.length) {
        chip.disabled = true;
        chip.setAttribute('aria-disabled', 'true');
      }

      text.className = 'mm-size-filter__option-text';
      label.className = 'mm-size-filter__chip-label mm-size-filter__option-label';
      label.textContent = item.label;

      count.className = 'mm-size-filter__chip-count mm-size-filter__option-count';
      count.textContent = String(item.count || 0);

      text.appendChild(label);
      chip.appendChild(text);
      chip.appendChild(count);
      setSizeChipState(chip);

      chip.addEventListener('click', function (event) {
        event.preventDefault();
        handleSizeChipToggle(chip);
      });

      chipList.appendChild(chip);
    });

    return ui;
  }

  function renameSizeFilterGroup(group) {
    if (!group) return;

    var title = group.querySelector('.collection-filters__filter-group-title, .collection-filters__filter-title');
    if (title) {
      title.textContent = 'Size';
    }
    group.setAttribute('aria-label', 'Size');
  }

  function enhanceSizeFilters(filtersContainer) {
    if (!isSupportedTemplate() || !filtersContainer) return;

    var groups = filtersContainer.querySelectorAll('.collection-filters__filter-group');
    groups.forEach(function (group) {
      if (group.hasAttribute(SIZE_FILTER_READY_ATTR)) return;

      var label = getFilterGroupLabel(group);
      if (!SIZE_FILTER_LABEL_PATTERN.test(label)) return;

      var list = group.querySelector('[data-filter-group-list], .collection-filters__filter-list');
      if (!list) return;

      var items = getSizeFilterGroups(group);
      if (!items.length) {
        group.hidden = true;
        return;
      }

      items.forEach(function (item) {
        item.links.forEach(function (link) {
          link.tabIndex = -1;
        });
      });

      renameSizeFilterGroup(group);
      group.classList.add('collection-filters__filter-group--size-ui');
      group.setAttribute(SIZE_FILTER_READY_ATTR, '');
      list.setAttribute('aria-hidden', 'true');
      group.insertBefore(createSizeFilterUI(group, items), list);
      syncSizeFilterUI(filtersContainer);
    });
  }

  function enhanceFilterWidgets(rootNode) {
    if (!isSupportedTemplate()) return;

    var filtersContainer = getFiltersContainer(rootNode);
    if (!filtersContainer) return;

    enhancePriceSliders(filtersContainer);
    enhanceRatingSliders(filtersContainer);
    enhanceSizeFilters(filtersContainer);
  }

  function syncEnhancedSliders(filtersContainer) {
    if (!filtersContainer) return;

    var priceSliders = filtersContainer.querySelectorAll('[data-mm-price-slider]');
    priceSliders.forEach(syncPriceSlider);

    syncSizeFilterUI(filtersContainer);
  }

  function refreshFilterEnhancements(rootNode) {
    var filtersContainers = getFiltersContainers(rootNode);
    if (!filtersContainers.length) return;

    filtersContainers.forEach(function (filtersContainer) {
      syncOptionAria(filtersContainer);
      enhanceFilterWidgets(filtersContainer);
      ensureActionButtons(filtersContainer);
      syncEnhancedSliders(filtersContainer);
      updateActionButtonsState(filtersContainer);
    });
  }

  function ensureActionButtons(rootNode) {
    if (!shouldEnable(rootNode)) return;

    var filtersContainer = getFiltersContainer(rootNode);
    if (!filtersContainer) return;

    var form = filtersContainer.querySelector('.filter-form');
    var legacyContent = filtersContainer.querySelector('[data-productgrid-filters-content] nav')
      || filtersContainer.querySelector('[data-productgrid-filters-content]')
      || filtersContainer;
    var actionsRoot = form || legacyContent;
    if (!actionsRoot) return;

    var actions = actionsRoot.querySelector(':scope > .' + ACTIONS_CLASS);
    if (!actions) {
      actions = actionsRoot.querySelector('.' + ACTIONS_CLASS);
    }
    if (!actions) {
      actions = document.createElement('div');
      actions.className = ACTIONS_CLASS;

      var clearButton = document.createElement('button');
      clearButton.type = 'button';
      clearButton.className = 'button-secondary filters-clear-button';
      clearButton.textContent = 'Clear';
      clearButton.setAttribute('data-filter-clear', '');

      actions.appendChild(clearButton);

      if (actionsRoot.closest('.' + MODAL_CLASS)) {
        actionsRoot.appendChild(actions);
      } else {
        actionsRoot.insertBefore(actions, actionsRoot.firstChild);
      }
    }

    updateActionButtonsState(filtersContainer);
  }

  function clearPendingFilters(filtersContainer) {
    if (!filtersContainer) return;

    var selectedOptions = filtersContainer.querySelectorAll(FILTER_OPTION_SELECTOR + '[data-filter-active]');
    selectedOptions.forEach(function (link) {
      setFilterOptionState(link, false);
    });

    var selectedLegacyOptions = filtersContainer.querySelectorAll(LEGACY_FILTER_ITEM_SELECTOR + '[data-filter-active="true"]');
    selectedLegacyOptions.forEach(function (item) {
      setLegacyFilterState(item, false);
    });

    var rangeInputs = filtersContainer.querySelectorAll(FILTER_RANGE_SELECTOR);
    rangeInputs.forEach(function (input) {
      input.value = '';
    });

    syncEnhancedSliders(filtersContainer);
    updateActionButtonsState(filtersContainer);
  }

  function getLegacyCollectionBasePath() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    if (parts[0] !== 'collections' || !parts[1]) {
      return window.location.pathname;
    }

    return '/' + parts.slice(0, 2).join('/');
  }

  function applyLegacyTagFilters(filtersContainer) {
    var activeItems = filtersContainer.querySelectorAll(LEGACY_FILTER_ITEM_SELECTOR + '[data-filter-active="true"]');
    var handles = [];

    activeItems.forEach(function (item) {
      var handle = getLegacyFilterHandle(item);
      if (handle) {
        handles.push(handle);
      }
    });

    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('constraint');

    var basePath = getLegacyCollectionBasePath();
    var targetPath = basePath;

    if (handles.length) {
      if (basePath.indexOf('/collections/vendors') === 0) {
        params.set('constraint', handles.join('+'));
      } else {
        targetPath = basePath.replace(/\/$/, '') + '/' + handles.join('+');
      }
    }

    var query = params.toString();
    window.location.href = targetPath + (query ? '?' + query : '');
  }

  function applyFilters(filtersContainer) {
    if (!filtersContainer) return;

    if (hasLegacyTagFilters(filtersContainer) && !hasFacetedFilters(filtersContainer)) {
      applyLegacyTagFilters(filtersContainer);
      return;
    }

    var params = new URLSearchParams(window.location.search);
    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0) {
        params.delete(key);
      }
    });
    params.delete('page');

    var activeInputs = filtersContainer.querySelectorAll(FILTER_OPTION_SELECTOR + '[data-filter-active]');
    activeInputs.forEach(function (input) {
      var name = input.getAttribute('data-name');
      var value = input.getAttribute('data-value');
      if (!name || value === null) return;
      params.append(name, value);
    });

    var rangeInputs = filtersContainer.querySelectorAll(FILTER_RANGE_SELECTOR);
    rangeInputs.forEach(function (input) {
      var name = input.name;
      if (!name) return;

      var value = input.value.trim();
      if (value) {
        params.set(name, value);
      } else {
        params.delete(name);
      }
    });

    var query = params.toString();
    window.location.search = query ? '?' + query : '';
  }

  function syncOptionAria(rootNode) {
    var filtersContainer = getFiltersContainer(rootNode);
    if (!filtersContainer) return;

    var links = filtersContainer.querySelectorAll(FILTER_OPTION_SELECTOR);
    links.forEach(function (link) {
      if (!link.hasAttribute('role')) {
        link.setAttribute('role', 'checkbox');
      }
      link.setAttribute('aria-checked', link.hasAttribute('data-filter-active') ? 'true' : 'false');
      if (link.hasAttribute('data-disabled')) {
        link.setAttribute('aria-disabled', 'true');
      }
    });

    var legacyLinks = filtersContainer.querySelectorAll(LEGACY_FILTER_LINK_SELECTOR);
    legacyLinks.forEach(function (link) {
      var item = getLegacyFilterItem(link);
      link.setAttribute('role', 'checkbox');
      link.setAttribute('aria-checked', item && item.getAttribute('data-filter-active') === 'true' ? 'true' : 'false');
      if (item && item.classList.contains('filter-item--disabled')) {
        link.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function handleLegacyFilterClick(event) {
    var link = event.target.closest(LEGACY_FILTER_LINK_SELECTOR);
    if (!link) return;
    var surfaceRoot = getFilterSurfaceRoot(link);
    if (!shouldEnable(surfaceRoot || link) || !surfaceRoot) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (link.getAttribute('aria-disabled') === 'true') return;

    toggleLegacyFilter(link);
    applyFilters(getCurrentFiltersContainer(link));
  }

  function handleLegacyFilterKeydown(event) {
    if (event.key !== ' ' && event.key !== 'Spacebar') return;

    var link = event.target.closest(LEGACY_FILTER_LINK_SELECTOR);
    if (!link) return;
    var surfaceRoot = getFilterSurfaceRoot(link);
    if (!shouldEnable(surfaceRoot || link) || !surfaceRoot) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (link.getAttribute('aria-disabled') === 'true') return;

    toggleLegacyFilter(link);
    applyFilters(getCurrentFiltersContainer(link));
  }

  function handleFilterClick(event) {
    var link = event.target.closest(FILTER_OPTION_SELECTOR);
    if (!link) return;
    var surfaceRoot = getFilterSurfaceRoot(link);
    if (!shouldEnable(surfaceRoot || link) || !surfaceRoot) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (link.hasAttribute('data-disabled') || link.getAttribute('aria-disabled') === 'true') return;

    toggleFilter(link);
    applyFilters(getCurrentFiltersContainer(link));
  }

  function handleFilterKeydown(event) {
    if (event.key !== ' ' && event.key !== 'Spacebar') return;

    var link = event.target.closest(FILTER_OPTION_SELECTOR);
    if (!link) return;
    var surfaceRoot = getFilterSurfaceRoot(link);
    if (!shouldEnable(surfaceRoot || link) || !surfaceRoot) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (link.hasAttribute('data-disabled') || link.getAttribute('aria-disabled') === 'true') return;

    toggleFilter(link);
    applyFilters(getCurrentFiltersContainer(link));
  }

  function handleRangeInput(event) {
    var input = event.target.closest(FILTER_RANGE_SELECTOR);
    if (!input) return;
    var surfaceRoot = getFilterSurfaceRoot(input);
    if (!shouldEnable(surfaceRoot || input) || !surfaceRoot) return;

    event.stopPropagation();
    var filtersContainer = getCurrentFiltersContainer(input);

    if (event.type === 'change') {
      applyFilters(filtersContainer);
      return;
    }

    syncEnhancedSliders(filtersContainer);
    updateActionButtonsState(filtersContainer);
  }

  function handleActiveChipClick(event) {
    var chip = event.target.closest(FILTER_ACTIVE_CHIP_SELECTOR);
    if (!chip) return;
    if (!shouldEnable() || !isInFiltersModal(chip)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var filtersContainer = getFiltersContainer(getFilterSurfaceRoot(chip));
    if (!filtersContainer) return;

    if (chip.matches(LEGACY_ACTIVE_CHIP_SELECTOR)) {
      var handle = chip.getAttribute('data-handle');
      var legacyItem = handle
        ? filtersContainer.querySelector(LEGACY_FILTER_ITEM_SELECTOR + '[data-handle="' + handle.replace(/"/g, '\\"') + '"]')
        : null;
      if (legacyItem) {
        setLegacyFilterState(legacyItem, false);
      }
      applyFilters(filtersContainer);
      return;
    }

    if (chip.hasAttribute('data-filter-range-remove')) {
      var minName = chip.getAttribute('data-min-name');
      var maxName = chip.getAttribute('data-max-name');
      clearRangeInputByName(filtersContainer, minName);
      clearRangeInputByName(filtersContainer, maxName);
      applyFilters(filtersContainer);
      return;
    }

    if (chip.hasAttribute(SIZE_FILTER_ACTIVE_CHIP_ATTR)) {
      var groupKey = chip.getAttribute(SIZE_FILTER_GROUP_KEY_ATTR);
      var sizeControl = getSizeControlByKey(filtersContainer, groupKey);
      var sizeLinks = getSizeControlLinks(sizeControl);
      sizeLinks.forEach(function (link) {
        setFilterOptionState(link, false);
      });

      removeGroupedSizeActiveChips(filtersContainer, groupKey);
      applyFilters(filtersContainer);
      return;
    }

    var name = chip.getAttribute('data-name');
    var value = chip.getAttribute('data-value');
    var linkedOption = findFilterOption(filtersContainer, name, value);
    if (linkedOption) {
      setFilterOptionState(linkedOption, false);
    }

    applyFilters(filtersContainer);
  }

  function handleClearAllLinkClick(event) {
    var link = event.target.closest(FILTER_CLEAR_ALL_LINK_SELECTOR);
    if (!link) return;
    if (!shouldEnable() || !isInFiltersModal(link)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var clearAllContainer = getFiltersContainer(getFilterSurfaceRoot(link));
    clearPendingFilters(clearAllContainer);
    applyFilters(clearAllContainer);
  }

  function handleFilterSubmit(event) {
    if (!shouldEnable()) return;
    if (!isInFiltersModal(event.target)) return;
    if (!event.target.matches('.collection-filters__price-range-form')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function handleApplyClick(event) {
    var button = event.target.closest(FILTER_APPLY_SELECTOR);
    if (!button) return;
    if (!shouldEnable() || !isInFiltersModal(button)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    applyFilters(getFiltersContainer(getFilterSurfaceRoot(button)));
  }

  function handleClearClick(event) {
    var button = event.target.closest(FILTER_CLEAR_SELECTOR);
    if (!button) return;
    if (!shouldEnable() || !isInFiltersModal(button)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var clearContainer = getFiltersContainer(getFilterSurfaceRoot(button));
    clearPendingFilters(clearContainer);
    applyFilters(clearContainer);
  }

  function handleFiltersTriggerClick(event) {
    var trigger = event.target.closest(FILTERS_TRIGGER_SELECTOR);
    if (!trigger) return;
    if (!shouldEnable()) return;

    if (toggleSearchFilterDropdown(trigger, event)) return;

    window.requestAnimationFrame(refreshFilterEnhancements);
    window.setTimeout(refreshFilterEnhancements, 150);
  }

  function handleSearchFilterDropdownDocumentClick(event) {
    if (!isMobileSearchFilterDropdown()) return;

    var trigger = getSearchFilterTrigger();
    if (!trigger) return;

    var dropdown = getSearchFilterDropdown(trigger);
    if (!dropdown || !dropdown.classList.contains(SEARCH_FILTER_DROPDOWN_OPEN_CLASS)) return;
    if (trigger.contains(event.target) || dropdown.contains(event.target)) return;

    setSearchFilterDropdownOpen(trigger, false);
  }

  function handleSearchFilterDropdownKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    closeSearchFilterDropdown({ focusTrigger: true });
  }

  function handleSearchFilterDropdownResize() {
    if (isMobileSearchFilterDropdown()) return;
    resetSearchFilterDropdown();
  }

  function findSearchCardLink(card) {
    if (!card || !card.querySelectorAll) return null;

    var links = card.querySelectorAll(SEARCH_CARD_LINK_SELECTOR);
    for (var i = 0; i < links.length; i += 1) {
      if (links[i].getAttribute('href')) {
        return links[i];
      }
    }

    return null;
  }

  function handleSearchCardClick(event) {
    if (!isMobileSearchCardExperience()) return;
    if (event.defaultPrevented) return;
    if (typeof event.button === 'number' && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var card = event.target.closest(SEARCH_CARD_SELECTOR);
    if (!card || !card.closest('.productgrid--items')) return;
    if (event.target.closest(SEARCH_CARD_IGNORE_SELECTOR)) return;

    var link = findSearchCardLink(card);
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    window.location.href = href;
  }

  function bindSearchCardClicks() {
    if (document.documentElement.__mmSearchCardClickBound) return;
    document.documentElement.__mmSearchCardClickBound = true;
    document.addEventListener('click', handleSearchCardClick, true);
  }

  function bindFilterModalObserver() {
    if (document.documentElement.__mmFilterModalObserverBound) return;
    if (!window.MutationObserver || !document.body) return;

    document.documentElement.__mmFilterModalObserverBound = true;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== Node.ELEMENT_NODE) return;

          var modal = node.matches && node.matches('.' + MODAL_CLASS)
            ? node
            : node.querySelector && node.querySelector('.' + MODAL_CLASS);

          if (!modal) return;

          window.requestAnimationFrame(function () {
            refreshFilterEnhancements(modal);
          });
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function openFiltersFromNav() {
    var navTrigger = document.querySelector(NAV_FILTER_TRIGGER_SELECTOR);
    var filtersTrigger = document.querySelector(FILTERS_TRIGGER_SELECTOR);
    if (!navTrigger || !filtersTrigger) return;
    if (navTrigger.__mmFiltersBound) return;

    navTrigger.__mmFiltersBound = true;
    navTrigger.addEventListener('click', function (event) {
      if (!shouldEnable()) return;
      event.preventDefault();
      filtersTrigger.click();
      window.requestAnimationFrame(refreshFilterEnhancements);
      window.setTimeout(refreshFilterEnhancements, 150);
    });
  }

  function bindGlobalEvents() {
    if (document.documentElement.__mmSearchFiltersBound) return;
    document.documentElement.__mmSearchFiltersBound = true;

    document.addEventListener('click', handleFilterClick, true);
    document.addEventListener('keydown', handleFilterKeydown, true);
    document.addEventListener('click', handleLegacyFilterClick, true);
    document.addEventListener('keydown', handleLegacyFilterKeydown, true);
    document.addEventListener('input', handleRangeInput, true);
    document.addEventListener('change', handleRangeInput, true);
    document.addEventListener('submit', handleFilterSubmit, true);
    document.addEventListener('click', handleApplyClick, true);
    document.addEventListener('click', handleClearClick, true);
    document.addEventListener('click', handleActiveChipClick, true);
    document.addEventListener('click', handleClearAllLinkClick, true);
    document.addEventListener('click', handleFiltersTriggerClick, true);
    document.addEventListener('click', handleSearchFilterDropdownDocumentClick, false);
    document.addEventListener('keydown', handleSearchFilterDropdownKeydown, true);
    window.addEventListener('resize', handleSearchFilterDropdownResize);
  }

  function init() {
    bindStickySidebarOffsetSync();
    scheduleStickySidebarOffsetSync();

    bindSearchCardClicks();
    if (!shouldEnable()) return;

    refreshFilterEnhancements();
    if (isMobileSearchFilterDropdown()) {
      prepareSearchFilterDropdown(getSearchFilterTrigger());
    }
    openFiltersFromNav();
    bindGlobalEvents();
    bindFilterModalObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
